import Car3RightGridContainer from "../../../components/car/grid/Car3RightGrid";

const Car3RightGrid = () => {
  return <Car3RightGridContainer />;
};

export default Car3RightGrid;
